import React from 'react';
import ApiAccessScreen from '../../src/screens/ApiAccessScreen';
export default function OwnerApiAccess() { return <ApiAccessScreen />; }
